<template>
  <div class="onlineConsult">
    <div class="consultNap">
      <img src="../../assets/background/consult.jpg" alt="" />
      <div class="consultNapBox">
        <p class="consultNapTitle">水泵云服务团队将为您提供专业的咨询服务！</p>
        <p class="consultNapTel">服务热线请拨打0359-2191886</p>
        <p class="consultNapTelEng">The service hotline is 0359-2191886</p>
      </div>
    </div>
    <div class="consultMess">
      <el-form
        ref="ruleForm"
        :model="form"
        :rules="rules"
        label-position="left"
        label-width="80px"
        class="consultMessForm"
      >
        <el-form-item label="应用场景" prop="consultUuid">
          <el-select v-model="form.consultUuid" placeholder="请选择应用场景">
            <el-option v-for="(item,index) in deliveryTypeList" :key="index" :label="item.name" :value="item.uuid" >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="咨询问题" prop="content">
          <el-input
            type="textarea"
            v-model="form.content"
            placeholder="请将您的需求反馈给我们"
          ></el-input>
        </el-form-item>
        <div class="flex">
          <el-form-item
            label="联 系 人"
            style="margin-right: 12px"
            prop="contactName"
          >
            <el-input
              v-model="form.contactName"
              placeholder="请输入联系人信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input
              v-model="form.contactPhone"
              placeholder="请输入您的手机号码"
            ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="公司名称" prop="contactEnterprise">
          <el-input
            v-model="form.contactEnterprise"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <div class="flex verification">
          <el-form-item label="验 证 码" prop="verification">
            <el-input v-model="form.verification" class="yanInput"></el-input>
          </el-form-item>
          <!-- 验证码 -->
          <div @click="refreshCode">
            <s-identify :identifyCode="identifyCode" style="margin-left:10px"></s-identify>
          </div>
        </div>
        <el-form-item prop="checked" class="agreen">
          <el-checkbox label="我已阅读并同意" v-model="form.checked">
            <span @click="dialogVisible = true">我已阅读并同意</span>
            <span class="red" @click="getAgreement">《隐私协议》</span>
          </el-checkbox>
        </el-form-item>

        <div class="consultPrompt">
          <p>温馨提示：</p>
          <p>
            1、客服会在1个工作日内和您联系（工作时间周一至周五9：00—18：00）
          </p>
          <p>2、紧急问题请拨打0359-2191886进行快速解答</p>
        </div>

        <el-form-item class="primaryButton">
          <el-button type="primary" @click="onSubmit('ruleForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 协议 -->
    <el-dialog
        title="水泵云用户隐私协议"
        center
        :visible.sync="dialogVisible"
        width="900px">
      <el-scrollbar style="height: 600px" class="userscroll">
        <div v-html="content" class="vHtmlMess"></div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agree()">同意服务条款</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
// 验证码
import SIdentify from "@/components/identify/identify";
import {saveConsult, getDictionaryItem, getInfoByWordNo} from "../../utils/interface";

export default {
  // 在线咨询
  name: "onlineConsult",
  components: {
    SIdentify,
  },
  data() {
    return {
      dialogVisible:false,
      content: '',
      form: {
        consultUuid: "",
        content: "",
        contactName: "",
        contactPhone: "",
        contactEnterprise: "",
        verification: "",
        checked: '',
      },
      deliveryTypeList:[],
      rules: {
        consultUuid: [
          { required: true, message: "请选择应用场景", trigger: "blur" },
        ],
        content: [
          {
            required: true,
            message: "请将您的需求反馈给我们",
            trigger: "blur",
          },
        ],
        contactName: [
          { required: true, message: "请输入联系人信息", trigger: "blur" },
        ],
        contactPhone: [
          {
            required: true,
            validator: this.validatorPhone,
            trigger: "blur",
          },
        ],
        contactEnterprise: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        verification: [
          { required: true, validator: this.getCodes, trigger: "blur" },
        ],
        checked: [
          {
            required: true,
            message: "请勾选《隐私协议》",
            trigger: "change",
          },
        ],
      },
      // 验证码
      identifyCodes: "1234567890",
      identifyCode: "",
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    getInfoByWordNo({"wordNo":"ZCYYHYSXY"}).then((res)=>{
      if(res&&res.success){
        this.content = res.data.content;
      }
    });
  },
  created() {
    this.getDictionaryItem("consult_type")
  },
  methods: {
    getAgreement() {
      this.dialogVisible = true;
    },
    agree(){
      this.form.checked=true
      this.dialogVisible=false
    },
    onSubmit(formName) {
      if (!this.$store.state.isLogin) {
        this.$message.warning("您需要先登陆哦！")
        return false;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveConsult(this.form).then((res)=>{
            if(res.success===true){
              this.$message.success('提示用户可在买家工作台-服务-在线咨询查看反馈情况！')
              this.loading = false
              setTimeout(() => {
                this.form ={
                  consultUuid: "",
                  content: "",
                  contactName: "",
                  contactPhone: "",
                  contactEnterprise: "",
                  verification: "",
                  type: '',
                };
                this.$router.go(0);
              }, 1000)

            }else{
              this.$message.error(res.message)
              this.loading = false
            }
          }).catch(function() {
            this.$message.error("提交咨询错误");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 联系方式校验
    validatorPhone(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!this.validate.isMobile(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    },
    // 验证码
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    getCodes(rule, value, callback){
      if(this.form.verification == ''){
        callback(new Error("请输入验证码"));
      }else if(this.form.verification !== this.identifyCode){
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    },
    getDictionaryItem(val){
      getDictionaryItem({groupCode: val}).then((res)=>{
        this.deliveryTypeList = res
      })
    },
  },
};
</script>

<style scoped lang="less">
.userscroll{
  /deep/ .el-scrollbar__wrap{
    overflow-x: hidden!important;;
  }
}
.red {
  font-size: 14px;
  color: #ff0000;
}
.code {
  margin: 400px auto;
  width: 114px;
  height: 40px;
  border: 1px solid red;
}
.onlineConsult {
  background: #f9f9f9;
  .consultNap {
    position: relative;
    img {
      width: 100%;
    }
    .consultNapBox {
      width: 1200px;
      position: absolute;
      top: 37%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
      color: #ffffff;
      .consultNapTitle {
        font-size: 48px;
        margin-bottom: 14px;
      }
      .consultNapTel {
        font-size: 18px;
      }
      .consultNapTelEng {
        font-size: 10px;
      }
    }
  }
  .consultMess {
    background: #fff;
    width: 1200px;
    margin: 0 auto;
    // height: 919px;
    position: relative;
    top: -172px;
    box-shadow: 0px 0px 5px rgba(0, 47, 103, 0.1);
    border-radius: 10px;
    padding: 63px 37px 27px;
    box-sizing: border-box;
    .consultMessForm {
    }
    /deep/.el-form-item {
      margin-bottom: 50px;
    }
    /deep/.el-input--suffix .el-input__inner {
      width: 476px;
      height: 49px;
      background: #fafafa;
      border-radius: 4px;
      border: none;
    }
    /deep/.el-input__inner {
      width: 476px;
      height: 49px;
      background: #fafafa;
      border-radius: 4px;
      border: none;
    }
    /deep/.el-textarea__inner {
      width: 1030px;
      height: 200px;
      background: #fafafa;
      border-radius: 4px;
      border: none;
    }
    .yanInput {
      width: 210px !important;
      /deep/.el-input__inner {
        width: 100% !important;
      }
    }
    .verification {
      align-items: flex-start;
      img {
        width: 136px;
        height: 49px;
        margin-left: 11px;
      }
    }
    .agreen {
      margin-bottom: 20px;
      /deep/.el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  .consultPrompt {
    font-size: 14px;
    line-height: 30px;
    margin-top: 20px;
  }
  .primaryButton {
    text-align: center;
    margin-top: 34px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/onlineConsult.vue